import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export { getOnPremiseTextFieldContainerStyle } from "../order-type-preference-options/OrderTypePreferenceOptions.style";

export const SheetOuter = styled.div({
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minHeight: 0,
    height: "100%",
    boxSizing: "border-box",
});

export const ScrollBody = styled.div({
    flex: "1 1 auto",
    minHeight: 0,
    overflow: "auto",
    boxSizing: "border-box",
    WebkitOverflowScrolling: "touch",
});

export const InputWrapper = styled.div(({ theme }) => ({
    padding: `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium} !important`,
}));

export const HeaderBlock = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxSmall,
    marginBottom: theme.spacing.large,
    marginTop: theme.spacing.x5,
    flexShrink: 0,
}));

export const TitleText = styled(Text)({
    display: "block",
});

export const SubtitleText = styled(Text)({
    display: "block",
});

export const Divider = styled.div(({ theme }) => ({
    width: "100%",
    height: 1,
    background: theme.colors[theme.colorMode].border_Secondary,
    margin: `${theme.spacing.medium} 0 ${theme.spacing.large} 0`,
    flexShrink: 0,
}));

export const MobileBlock = styled.div({
    width: "100%",
    flexShrink: 0,
});

export const FooterBar = styled.div(({ theme }) => ({
    flexShrink: 0,
    width: "100%",
    boxSizing: "border-box",
    padding: `${theme.spacing.small} ${theme.spacing.medium}`,
    paddingBottom: `calc(${theme.spacing.small} + var(--sab, 0px))`,
    background: theme.colors[theme.colorMode].background_Primary,
    boxShadow: theme.elevation[theme.colorMode].liftedNegative.boxShadow,
}));
